import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import TrustBar from '../../../components/feature/TrustBar';
import ProcessSection from '../../../components/feature/ProcessSection';
import WhyChooseUsSection from '../../../components/feature/WhyChooseUsSection';
import TestimonialsSection from '../../../components/feature/TestimonialsSection';
import FAQSection from '../../../components/feature/FAQSection';
import FinalCTASection from '../../../components/feature/FinalCTASection';
import ServiceAreasSection from '../../../components/feature/ServiceAreasSection';
import AIAnswerBlock from '../../../components/feature/AIAnswerBlock';
import MidPageCTA from '../../../components/feature/MidPageCTA';
import ColoradoSpringsHero from './components/ColoradoSpringsHero';
import ColoradoSpringsServicesOverview from './components/ColoradoSpringsServicesOverview';

const coloradoSpringsFAQs = [
  {
    question: 'Who provides environmental remediation services in Colorado Springs?',
    answer:
      'ECOS Environmental & Disaster Restoration provides certified environmental remediation in Colorado Springs, including asbestos abatement, mold remediation, hazardous material removal, and disaster restoration. Their team serves El Paso County and surrounding areas with full EPA and OSHA compliance.',
  },
  {
    question: 'How quickly can you start a project in Colorado Springs?',
    answer:
      'ECOS Environmental maintains dedicated teams serving the Colorado Springs area. Site assessments can typically be scheduled within 24 to 48 hours. For environmental emergencies in Colorado Springs, 24/7 rapid response is available immediately.',
  },
  {
    question: 'Do you handle commercial environmental projects in Colorado Springs?',
    answer:
      'Yes. ECOS Environmental specializes in commercial, industrial, and government remediation throughout Colorado Springs. Their team has extensive experience with local building codes, El Paso County regulations, and Colorado state environmental requirements.',
  },
  {
    question: 'What areas near Colorado Springs do you serve?',
    answer:
      'In addition to Colorado Springs, ECOS Environmental serves the entire El Paso County region including Fountain, Monument, Manitou Springs, Woodland Park, Security-Widefield, and Falcon, as well as the broader Colorado Front Range corridor.',
  },
  {
    question: 'Do you offer emergency disaster restoration in Colorado Springs?',
    answer:
      'Yes. ECOS Environmental provides 24/7 emergency disaster restoration throughout Colorado Springs for flood damage, fire contamination, and environmental hazard events. Emergency teams are deployed immediately to contain damage and begin compliant restoration.',
  },
];

export default function ColoradoSpringsPage() {
  return (
    <main>
      <Navbar />
      <ColoradoSpringsHero />
      <TrustBar />
      <ColoradoSpringsServicesOverview />
      <MidPageCTA
        headline="Environmental Emergency in Colorado Springs? Call Now."
        subtext="24/7 rapid response teams available across El Paso County and the Front Range."
      />
      <AIAnswerBlock
        question="Environmental Remediation Services in Colorado Springs"
        answer="ECOS Environmental & Disaster Restoration provides comprehensive environmental remediation services in Colorado Springs, including asbestos abatement, mold remediation, hazardous material removal, lead paint removal, and emergency disaster restoration. Their team ensures full compliance with local, state, and federal environmental regulations. As Colorado Springs' trusted environmental contractor, ECOS serves commercial properties, industrial facilities, and government sites throughout El Paso County and the surrounding Front Range region."
        services={[
          { label: 'Asbestos Abatement' },
          { label: 'Mold Remediation' },
          { label: 'Disaster Restoration' },
          { label: 'Hazardous Material Removal' },
          { label: 'Lead Paint Removal' },
          { label: 'Environmental Consulting' },
        ]}
      />
      <ProcessSection />
      <WhyChooseUsSection headline="Colorado Springs' Trusted Environmental Remediation Partner" />
      <ServiceAreasSection
        locationNote="Colorado Springs & Surrounding Areas"
        extraCities={['Fountain', 'Monument', 'Manitou Springs', 'Woodland Park']}
      />
      <TestimonialsSection />
      <MidPageCTA
        headline="Trusted by Colorado Springs' Commercial & Industrial Leaders"
        subtext="Request your free site assessment today — full compliance planning included."
      />
      <FAQSection faqs={coloradoSpringsFAQs} title="Colorado Springs Environmental Services FAQ" />
      <FinalCTASection />
      <Footer />
    </main>
  );
}
